import { render, staticRenderFns } from "./ContentTypeDownload.vue?vue&type=template&id=647447a6&scoped=true&"
import script from "./ContentTypeDownload.vue?vue&type=script&lang=js&"
export * from "./ContentTypeDownload.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeDownload.vue?vue&type=style&index=0&id=647447a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647447a6",
  null
  
)

export default component.exports